import { Component, OnInit } from '@angular/core';
import { UtilityService } from '../../../services/Acc_Utility.service';
import { Global } from '../../global';
import { Observable } from 'rxjs';
import { AccountMappingService } from '../../../services/AccountMappingService';
import { GL_MasterService } from '../../../services/Acc_GL_Master.service';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { InvoiceService } from '../../../services/Acc_InvoiceService';
import { MatDatepickerInputEvent, MatSnackBar, SELECT_PANEL_INDENT_PADDING_X } from '@angular/material';
import * as moment from 'jalali-moment';
import { DariCalendarService } from '../../../services/DariCalendar';
import { EditInvoiceDialogComponent } from '../edit-invoice-dialog/edit-invoice-dialog.component';
import { MatDialog } from '@angular/material';
import * as $ from 'jquery';
import { Txn_Invoice } from '../../../models/Txn_Invoice';
import { ExcelService } from '../../../services/ExcelService';
import { UserDetails } from '../../../models/userDetails.interface';
import { UserService } from '../../../services/user.service';
import { DashboardService } from '../../../services/dashboard.service';
import { DiscountService } from '../../../services/DiscountService';
import { DiscountEditDialogComponent } from '../../discount/discount-edit-dialog/discount-edit-dialog.component';
import { DiscountAddComponent } from '../../discount/discount-add/discount-add.component';

@Component({
  selector: 'app-student-discount-list',
  templateUrl: './student-discount-list.component.html',
  styleUrls: ['./student-discount-list.component.css']
})
export class StudentDiscountListComponent implements OnInit {

  ArrLabels: any;
  labels: any = {};
  StudentAccounts: any = "";
  selectedAccountNumber: string = 'all';
  selectedAccountName: string;
  StudentName: string = "";
  StudentId: string = "";

  clear_status: string = 'A';
  expiry_status: string = 'A';
  semester: number = 0;
  year: number = 0;
  EntrySemester: number = 0;
  fromDate: string;
  toDate: string;
  isPrintable: boolean;
  isFeeSemester: boolean = false;
  ArrAccountMaps: any;
  studentMasterAccount: string;
  filteredOptions: Observable<string[]>;
  myControl = new FormControl();
  studentDiscountList: any = {};
  departmentList: any;
  st_department: number = 0;
  printVariables: any = {};
  recordCount: number;
  amount_sum: number = 0;
  userDetails: UserDetails;
  branch: string;
  DateCheck = true;
  years = new Array();
  constructor(
    public dialog: MatDialog,
    private UtilityService: UtilityService,
    private global: Global,
    private AccountMapService: AccountMappingService,
    private GL_MasterService: GL_MasterService,
    private DiscountService: DiscountService,
    private DariCalendar: DariCalendarService,
    private snackBar: MatSnackBar,
    private excelService: ExcelService,
    private userService: UserService,
    private userDetailService: DashboardService
  ) {
    //this.getInvoices();
    this.userDetailService.getUserDetails()
      .subscribe((userDetails: UserDetails) => {
        this.userDetails = userDetails;
        console.log(`user details ` + this.userDetails["email"]);
      }, error => {
        console.log(error);
        //this.notificationService.printErrorMessage(error);
      });
  }

  ngOnInit() {
    Array.from({ length: 30 }, (x, i) => this.years.push(i + 1380));
    this.selectedAccountName = "حساب کاربردی محصل";
    this.getLabels();
    this.getDepartments();
    this.getBranchId();
  }

  isBranchId: number = -1;
  getBranchId() {
     
    let data = localStorage.getItem('accessKeyUser');
    let dataAccess = JSON.parse(data);
    let dataAccessUrl = dataAccess.filter(f => f.accessKeyUrl == "/discount")[0];
    if (dataAccessUrl != undefined) {
      if (dataAccessUrl.isMainBranch)
        this.isBranchId = 1;
      else if (dataAccessUrl.isWestBranch)
        this.isBranchId = 2;
      else
        this.isBranchId = 0;
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.StudentAccounts.filter(option => option.gL_ChildCode.toLowerCase().includes(filterValue));
  }

  getDepartments() {
    this.departmentList = this.UtilityService.getDepartments().subscribe(response => {
      console.log(response);
      this.departmentList = response;
    })
  }

  AccountChanged(event, gL_ChildDesc, gL_ChildCode) {
    console.log(event.isUserInput);
    if (event.isUserInput === true) {
      console.log(gL_ChildDesc);
      this.selectedAccountName = gL_ChildDesc;
    }
  }

  getStudentDiscount() {
    this.DiscountService.getStudentDiscount(this.StudentId, this.StudentName, this.semester, this.year, this.EntrySemester, this.st_department, this.isBranchId)
      .subscribe(response => {
        this.studentDiscountList = response;
        this.recordCount = this.studentDiscountList.length;
        this.amount_sum = 0;
        for (let inv in this.studentDiscountList) {
          // calculate sum
          this.amount_sum += this.studentDiscountList[inv].inv_amount;
        }
      });
  }

  editDiscountFee(student: any): void {
    let discountValue: any;
    let currentStudent = student["studentID"];
    this.DiscountService.getDiscount(currentStudent, '0', '0','0', this.isBranchId).subscribe(r => {
      let rData = r as any[];
      if (rData != null && rData.length > 0) {
        discountValue = rData[0];
        const dialogRef = this.dialog.open(DiscountEditDialogComponent, {
          width: '1000px',
          data: {
            studentID: discountValue["studentID"],
            discount: discountValue["discount"],
            studentDetails: discountValue["studentDetails"],
            comment: discountValue["comment"],
            link: discountValue["link"]
          }
        });
      } else {
        const dialogRef = this.dialog.open(DiscountAddComponent, {
          width: '1000px',
          data: {
            studentID: currentStudent,
            discount: '0',
            studentDetails: '',
            comment: '',
            link: ''
          }
        });

      }
    });


  }


  openSnackBarInfo(message: string, action: string) {
    let snackBarRef = this.snackBar.open(message, action, {
      duration: 2000,
    });
    snackBarRef.closeWithAction = function () {
      snackBarRef.dismiss();
    }
  }

  printFilteredInvoices() {
    setTimeout(() => {
      var printWindow: any
      var content = $("#reportContent").prop('outerHTML');

      printWindow = window.open('', '', '');
      printWindow.document.write('<html><head><title>Print</title>');
      var _link = $('link');
      var _style = $('style');
      var strstyle = '';
      var _script = $('script');
      for (var k = 0; k < _link.length; k++)
        printWindow.document.write(_link[k].outerHTML);
      for (var i = 0; i < _style.length; i++)
        printWindow.document.write(_style[i].outerHTML);
      for (var j = 0; j < _script.length; j++)
        printWindow.document.write(_script[j].outerHTML);
      printWindow.document.write(' <style> .action-row { display: none; }  </style>    </head><body  style="-webkit-print-color-adjust: exact; margin:25px; border: 1px solid #000; margin-top: 1px;direction: rtl; "  >');

      printWindow.document.write(`
      <table class="table AESLog table-responsive" style="font-family: IranianSansRegular;">
      <tr>
        <td style="width:25vw;">
          <img src="assets/images/ministry.jpg" width="145px"; style="float:right;"/> 
        </td>
        <td style="text-align:center; width:50vw;">
            وزارت تحصیلات عالی<br />
            ریاست موسسات تحصیلات عالی خصوصی<br />
            موسسه تحصیلات عالی طبی افغان سویس<br />
          <p> لیست تعرفه محصلین </p>
        </td>
        <td style="width:25vw;" >
          <img src="assets/images/rbulogo.gif" width="140px" style="float:left"/>
        </td>

      </tr>
    </table> `);

      printWindow.document.write(content);
      printWindow.document.write(`<script> $(".btnprint").css("display", "none");</script>
      <script> $(".btndelete").css("display", "none"); $(".btnReverse").css("display", "none");$(".btnEdit").css("display", "none");</script>  </body ></html>`);

    }, 1000);
  }
  printInvoice(department: string, udF2: string, udF3: string, semester: string, expiryDate: string, inv_no: string, stAcc: string, gL_ChildDesc: string, amount: string, issueDate: string,
    issue_remark: string, trn_ref_issue: string, trn_discount: string, payable_amount: string, CheckerID: string, invoiceDesc: string, bankAccountNameFa: string, bankAccountNumber: string, installmentNumber: number) {
    this.printVariables['inv_no'] = inv_no;
    this.printVariables['trn_amount'] = amount;
    this.printVariables['trn_date'] = issueDate;
    this.printVariables['trn_desc'] = issue_remark;
    this.printVariables['trn_discount'] = trn_discount;
    this.printVariables['payable_amount'] = payable_amount;
    this.printVariables['student_account'] = stAcc;
    this.printVariables['gL_ChildDesc'] = gL_ChildDesc;
    this.printVariables['name'] = gL_ChildDesc.split("ولد")[0];
    this.printVariables['fname'] = gL_ChildDesc.split("ولد")[1];
    this.printVariables['trn_ref_no'] = trn_ref_issue;
    this.printVariables['CheckerID'] = CheckerID;
    this.printVariables['expDate'] = expiryDate;
    this.printVariables['semester'] = semester;
    this.printVariables['udF2'] = udF2;
    this.printVariables['udF3'] = udF3;
    this.printVariables['department'] = department;
    this.printVariables['invoiceDesc'] = invoiceDesc;
    this.isPrintable = invoiceDesc == 'هزینه چانس' || invoiceDesc == 'هزینه داخله' || invoiceDesc == 'فیس سمستر';
    this.printVariables['bankAccountNameFa'] = bankAccountNameFa;
    this.printVariables['bankAccountNumber'] = bankAccountNumber;
    this.printVariables['installmentNumber'] = installmentNumber;
    if (installmentNumber == 1)
      this.printVariables['installmentMonthTitle'] = "قسط اول";
    if (installmentNumber == 2)
      this.printVariables['installmentMonthTitle'] = "قسط دوم";
    if (installmentNumber == 3)
      this.printVariables['installmentMonthTitle'] = "قسط سوم";
    if (installmentNumber == 4)
      this.printVariables['installmentMonthTitle'] = "قسط چهارم";
    if (installmentNumber == 5)
      this.printVariables['installmentMonthTitle'] = "قسط پنجم";
    if (installmentNumber == 6)
      this.printVariables['installmentMonthTitle'] = "قسط ششم";

    this.printVariables['feeTitle'] = (invoiceDesc == 'فیس سمستر') ? "فیس ماهوار" : "مبلغ فیس";
    this.isFeeSemester = invoiceDesc == 'فیس سمستر';
    this.printVariables['trn_discount'] = (parseInt(trn_discount) * 100) / (parseInt(trn_discount) + parseInt(payable_amount));

    setTimeout(() => {
      var printWindow: any
      var content = $("#print-section").prop('outerHTML');
      printWindow = window.open('', '', '');
      printWindow.document.write('<html><head><title>Print</title>');
      var _link = $('link');
      var _style = $('style');
      var strstyle = '';
      var _script = $('script');
      for (var k = 0; k < _link.length; k++)
        printWindow.document.write(_link[k].outerHTML);
      for (var i = 0; i < _style.length; i++)
        printWindow.document.write(_style[i].outerHTML);
      for (var j = 0; j < _script.length; j++)
        printWindow.document.write(_script[j].outerHTML);
      printWindow.document.write('</head><body style="-webkit-print-color-adjust: exact;     margin-top: 1px;"  >');
      printWindow.document.write(content);
      printWindow.document.write('<script> $(".AES").css("display", "block");</script> </body ></html>');
    }, 1000);
  }


  openDialog(inv_no: string, issueDate: Date, expiryDate: Date, issue_remark: string, st_name: string, semester: number): void {
    const dialogRef = this.dialog.open(EditInvoiceDialogComponent, {
      width: '250px',
      backdropClass: 'custom-dialog-backdrop-class',
      panelClass: 'custom-dialog-panel-class',
      data: { inv_number: inv_no, inv_Date: issueDate, expiryDate: expiryDate, remarks: issue_remark, st_name: st_name, semester: semester }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        var inv: Txn_Invoice = result.data;

        var _p_issue_date = moment(inv.issueDate).format('jYYYY-jMM-jDD');
        var _issue_date = moment.from(_p_issue_date, 'fa').format('YYYY-MM-DD');

        var _p_expiry_date = moment(inv.expiryDate).format('jYYYY-jMM-jDD');
        var _expiry_date = moment.from(_p_expiry_date, 'fa').format('YYYY-MM-DD');

        inv.issueDate = new Date(_issue_date);
        inv.expiryDate = new Date(_expiry_date);

        //this.DiscountService.upd(inv).subscribe(response => {
        //  if (response == 'Success') {
        //    this.getInvoices();
        //    this.openSnackBarInfo('آپدیت شد', '');
        //  }
        //  else {
        //    this.openSnackBarInfo('خطا در آپدیت', '');
        //  }

        //});
      }
    });
  }
  getLabels() {
    this.UtilityService.getLabels('student-discount-list', this.global.lang)
      .subscribe(response => {
        if (response) {
          this.ArrLabels = response;
          this.setLabels();
          console.log(this.ArrLabels);
        }
      },
        error => console.log(error))
  }
  // AccountChanged(event)
  // {
  //   this.selectedAccountName = event.source.triggerValue
  // }
  setLabels() {
    //title
    this.labels['student-discount-list-title'] = this.ArrLabels.find((o: any) => o.key === 'student-discount-list-title').value;

    // labels
    this.labels['studentAccount'] = this.ArrLabels.find((o: any) => o.key === 'studentAccount').value;
    this.labels['selectedStudentName'] = this.ArrLabels.find((o: any) => o.key === 'selectedStudentName').value;

    this.labels['InvoiceStatus'] = this.ArrLabels.find((o: any) => o.key === 'InvoiceStatus').value;
    this.labels['allStudents'] = this.ArrLabels.find((o: any) => o.key === 'allStudents').value;
    this.labels['NotPaid'] = this.ArrLabels.find((o: any) => o.key === 'NotPaid').value;
    this.labels['Paid'] = this.ArrLabels.find((o: any) => o.key === 'Paid').value;
    this.labels['allInvoices'] = this.ArrLabels.find((o: any) => o.key === 'allInvoices').value;
    this.labels['department'] = this.ArrLabels.find((o: any) => o.key === 'department').value;

    // grid labels
    this.labels['InvNO'] = this.ArrLabels.find((o: any) => o.key === 'InvNO').value;
    this.labels['StudentAccName'] = this.ArrLabels.find((o: any) => o.key === 'StudentAccName').value;
    this.labels['inv_amount'] = this.ArrLabels.find((o: any) => o.key === 'inv_amount').value;
    this.labels['issueDate'] = this.ArrLabels.find((o: any) => o.key === 'issueDate').value;
    this.labels['expiryDate'] = this.ArrLabels.find((o: any) => o.key === 'ExpiryDate').value;
    this.labels['clearDate'] = this.ArrLabels.find((o: any) => o.key === 'clearDate').value;
    this.labels['clear_status'] = this.ArrLabels.find((o: any) => o.key === 'clear_status').value;
    this.labels['issue_remark'] = this.ArrLabels.find((o: any) => o.key === 'issue_remark').value;
    this.labels['fromDate'] = this.ArrLabels.find((o: any) => o.key === 'fromDate').value;
    this.labels['toDate'] = this.ArrLabels.find((o: any) => o.key === 'toDate').value;

    // Alerts
    this.labels['StudentAccountMandatory'] = this.ArrLabels.find((o: any) => o.key === 'StudentAccountMandatory').value;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/management/student-discount-list/student-discount-list.component.ts